import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants'
import {NatPostFileRequest, NatPostFileResponse} from './NatPostFile'
import {NatBaseResponseInterface} from '../../common/repository/NatBaseResponseInterface'
import {ValidateUploadFile} from './NatFileNameValidate'

export interface FileVoidResponse extends NatBaseResponseInterface {
    details: null
}

export class NatFileRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    async fileUpload(request: NatPostFileRequest): Promise<NatPostFileResponse> {
        return await this.http.post(
            `/api/resident/files`,
            request,
            ContentType.JSON,
        )
    }

    async getDataUrl(url: string): Promise<string> {
        return (await this.http.getDataUrl(url)) ?? '';
    }

    // ファイルアップロードの事前チェック
    async validateUploadFile(
        request: ValidateUploadFile,
    ): Promise<FileVoidResponse> {
        return await this.http.post(
            '/api/common/validate/files/pre-upload',
            request,
            ContentType.JSON,
        )
    }
}
